<template>
  <v-app>
    <v-layout
      row
      fill-height
      class="d-flex align-center justify-center"
      style="background-color: #f5f5f5;"
    >
      <v-card
        variant="outlined"
        class="pa-8 rounded-xl text-center"
        width="450"
      >
        <div v-if="loading">
          <v-progress-circular
            indeterminate
            color="primary"
            size="64"
            class="mb-4"
          />
          <div class="text-h6 text-primary font-weight-bold">
            Autenticando...
          </div>
          <div class="text-body-1 text-medium-emphasis mt-2">
            Validando seu acesso externo. Por favor, aguarde.
          </div>
        </div>

        <div v-else-if="error">
          <v-icon
            icon="mdi-alert-circle-outline"
            color="error"
            size="64"
            class="mb-4"
          />
          <div class="text-h6 text-error font-weight-bold mb-2">
            Falha na Autenticação
          </div>
          <div class="text-body-1 text-medium-emphasis mb-6">
            {{ errorMessage }}
          </div>
          <v-btn
            color="primary"
            variant="flat"
            to="/"
            class="rounded-xl"
          >
            Ir para o Login Manual
          </v-btn>
        </div>
      </v-card>
    </v-layout>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AutoLogin',
  data: () => ({
    loading: true,
    error: false,
    errorMessage: ''
  }),

  async mounted () {
    const token = this.$route.query.token

    if (!token) {
      this.showError('Token de acesso não fornecido na URL.')
      return
    }

    try {
      await this.AutoLoginWithToken(token)
      this.$router.replace('/homeMedico')
    } catch (err) {
      console.error('Erro no auto-login:', err)
      const message = err?.message || 'Seu token é inválido ou expirou. Por favor, tente o login manual.'
      this.showError(message)
    }
  },

  methods: {
    ...mapActions(['AutoLoginWithToken']),

    showError (message) {
      this.loading = false
      this.error = true
      this.errorMessage = message
    }
  }
}
</script>
